import { Box, Typography } from "@mui/material";
import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import { ExchangeIcon } from "src/Common/components/ExchangeIcon";

const columns: GridColDef[] = [
  { field: "id", headerName: "id", width: 200 },
  {
    renderCell: (params) => {
      return <ExchangeIcon name={params.row.id} />;
    },
    field: "name",
    headerName: "Asset",
    width: 200,
  },
];

export const ExchangeAssetsTable = ({ rows }: { rows: GridRowsProp }) => {
  return (
    <Box height="90vh">
      <Typography style={{ padding: "1rem" }} variant="h6">
        Exchange Assets
      </Typography>
      <DataGrid rows={rows} columns={columns} />
    </Box>
  );
};
